import type { NavFeatures } from "./nav-items";

/**
 * Which optional areas this bundle was built with (6 Oct, decision 35).
 *
 * Usage (`/admin/usage`) exists on `dev` only and has no `/auth/me` flag: the
 * admin role alone gates it. Asking Vite whether its feature folder is in the
 * build lets one nav file serve every branch without listing a page that is
 * not there. The glob is lazy (no `eager`), so nothing is imported here; the
 * route's own `lazy()` import is what loads the page.
 */
export const NAV_FEATURES: NavFeatures = {
  usage: Object.keys(import.meta.glob("/src/features/usage/index.ts")).length > 0,
};
